var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptysUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 14.5133C41.7915 12.4823 44.1589 11.045 46.7874 10.3926C49.4158 9.74026 52.1806 9.90375 54.7138 10.8613C57.2471 11.8189 59.4286 13.5252 60.9683 15.7532C62.5079 17.9812 63.3326 20.6251 63.3326 23.3333C63.3326 26.0415 62.5079 28.6855 60.9683 30.9135C59.4286 33.1414 57.2471 34.8477 54.7138 35.8053C52.1806 36.7629 49.4158 36.9264 46.7874 36.274C44.1589 35.6216 41.7915 34.1843 40 32.1533M50 70H10V66.6667C10 61.3623 12.1071 56.2753 15.8579 52.5245C19.6086 48.7738 24.6957 46.6667 30 46.6667C35.3043 46.6667 40.3914 48.7738 44.1421 52.5245C47.8929 56.2753 50 61.3623 50 66.6667V70ZM50 70H70V66.6667C70.0005 63.1557 69.0767 59.7065 67.3216 56.6657C65.5664 53.6249 63.0417 51.0997 60.0012 49.344C56.9608 47.5883 53.5117 46.664 50.0007 46.6638C46.4897 46.6637 43.0406 47.5879 40 49.3433M43.3333 23.3333C43.3333 26.8696 41.9286 30.2609 39.4281 32.7614C36.9276 35.2619 33.5362 36.6667 30 36.6667C26.4638 36.6667 23.0724 35.2619 20.5719 32.7614C18.0714 30.2609 16.6667 26.8696 16.6667 23.3333C16.6667 19.7971 18.0714 16.4057 20.5719 13.9052C23.0724 11.4048 26.4638 10 30 10C33.5362 10 36.9276 11.4048 39.4281 13.9052C41.9286 16.4057 43.3333 19.7971 43.3333 23.3333Z",
    stroke: "#D1D5DB",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptysUser);
export default __webpack_public_path__ + "static/media/Emptys_User.f6c4f522d610775a3e161e0619645ca9.svg";
export { ForwardRef as ReactComponent };